export enum ChainId {
  MAINNET = 1,
  GOERLI = 5,
  SEPOLIA = 11155111,
  OPTIMISM = 10,
  OPTIMISM_GOERLI = 420,
  ARBITRUM_ONE = 42161,
  ARBITRUM_GOERLI = 421613,
  POLYGON = 137,
  POLYGON_MUMBAI = 80001,
  CELO = 42220,
  CELO_ALFAJORES = 44787,
  GNOSIS = 100,
  MOONBEAM = 1284,
  BNB = 56,
  AVALANCHE = 43114,
  BASE_GOERLI = 84531,
  BASE = 8453,
  DBK = 20240603,
  BERACHAIN = 80094,
  HYPERLIQUID = 999,
  SONIC = 146,
  KATANA = 747474,
  MITOSIS = 124816,
  SOMNIA = 5031,
  ZEROG = 16661,
  PLASMA = 9745,
  MONAD_TESTNET = 10143,
  MONAD = 143,
  MEGAETH = 4326,
  STABLE = 988,
}

export const SUPPORTED_CHAINS = [
  ChainId.MAINNET,
  ChainId.OPTIMISM,
  ChainId.OPTIMISM_GOERLI,
  ChainId.ARBITRUM_ONE,
  ChainId.ARBITRUM_GOERLI,
  ChainId.POLYGON,
  ChainId.POLYGON_MUMBAI,
  ChainId.GOERLI,
  ChainId.SEPOLIA,
  ChainId.CELO_ALFAJORES,
  ChainId.CELO,
  ChainId.BNB,
  ChainId.AVALANCHE,
  ChainId.BASE,
  ChainId.BASE_GOERLI,
  ChainId.DBK,
  ChainId.BERACHAIN,
  ChainId.HYPERLIQUID,
  ChainId.SONIC,
  ChainId.KATANA,
  ChainId.MITOSIS,
  ChainId.SOMNIA,
  ChainId.ZEROG,
  ChainId.PLASMA,
  ChainId.MONAD_TESTNET,
  ChainId.MONAD,
  ChainId.MEGAETH,
  ChainId.STABLE,
] as const
export type SupportedChainsType = typeof SUPPORTED_CHAINS[number]

export enum NativeCurrencyName {
  // Strings match input for CLI
  ETHER = 'ETH',
  MATIC = 'MATIC',
  CELO = 'CELO',
  GNOSIS = 'XDAI',
  MOONBEAM = 'GLMR',
  BNB = 'BNB',
  AVAX = 'AVAX',
  BERA = 'BERA',
  HYPE = 'HYPE',
  SONIC = 'S',
  MITOSIS = 'MITO',
  SOMNIA = 'SOMI',
  ZEROG = '0G',
  PLASMA = 'XPL',
  MONAD = 'MON',
  STABLE = 'gUSDT',
}
